

<template>
  <div
    class="sign-in-form-container bg-grey-gradient"
    :class="{ 'loading-finish': selectedPortal }"
  ></div>
</template>
  
  
  
  <script>
import { AuthAPIInstance } from "../api";
import { AuthHelper } from "../helpers/auth.helper";
export default {
  data: () => ({}),
  async mounted() {
    try {
      const resp = await AuthAPIInstance.signInGoogle(this.$route.query.code, {
        toast: {
          message: "Success. Sign In completed.",
        },
      });

      await AuthHelper.setToken(resp.token);
      await AuthHelper.setUser(resp.user);

      AuthHelper.setRefresh(resp.exp);

      console.log("Google sign-in response", resp);

      this.$router.push("/dashboard");
    } catch (error) {
      console.error("Google sign-in error", error);
      this.$router.push("/sign-in");
    }
  },
  components: {},
  methods: {},
};
</script>
  
  <style lang="scss" scoped>
</style>
  
  
  
  